import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useCallback } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmLogin } from "rest/requests";
import swal from "sweetalert";
import PropTypes from "prop-types";
import { getUserByEmail } from "rest/requests";

export function ConfirmationCode({ setIsConfirming, user, setUserData }) {
  const [securityCode, setSecurityCode] = useState(0);
  const navigate = useNavigate();
  const confirmLogin = useCallback(async () => {
    try {
      await ConfirmLogin(user, securityCode);
      console.log("ok");
      const _userData = await getUserByEmail(user);
      setUserData(_userData[0]);
      navigate("/reportes/resumen_ventas", { replace: true });
    } catch {
      console.log("error");
      swal("Error accediendo al sistema", "Codigo incorrecto", "error");
    }
  }, [securityCode, user]);

  return (
    <div>
      <MDBox pt={4} pb={3} px={3}>
        <MDBox mb={2}>
          <MDInput
            type="number"
            label="Entre el codigo de seguridad"
            variant="standard"
            fullWidth
            InputLabelProps={{ shrink: true }}
            onChange={(event) => setSecurityCode(event.target.value)}
          />
        </MDBox>
        <MDBox>
          <MDButton
            variant="outlined"
            size="medium"
            color="dark"
            onClick={() => confirmLogin()}
            style={{ margin: "10px" }}
            fullWidth
          >
            Confirmar
          </MDButton>

          <MDButton
            variant="outlined"
            size="medium"
            color="error"
            onClick={() => setIsConfirming(false)}
            style={{ margin: "10px" }}
            fullWidth
          >
            Cancelar
          </MDButton>
        </MDBox>
        <MDBox>
          <MDTypography variant="caption" color="text" size="small">
            * El código se envió a su correo electronico registrado
          </MDTypography>
        </MDBox>
      </MDBox>
    </div>
  );
}

ConfirmationCode.defaultProps = {
  setIsConfirming: null,
  user: null,
  setUserData: null,
};

ConfirmationCode.propTypes = {
  user: PropTypes.string,
  setIsConfirming: PropTypes.func,
  setUserData: PropTypes.func,
};
